import { Box } from '@mui/material';
import MUITooltip, { TooltipProps } from '@mui/material/Tooltip';
import { CSSProperties, useState } from 'react';

type CFRATooltipProps = {
    tooltipContainerStyles?: CSSProperties;
} & TooltipProps;

const Tooltip = ({ children, tooltipContainerStyles, ...rest }: CFRATooltipProps) => {
    const [renderTooltip, setRenderTooltip] = useState(false);
    return (
        <div
            onMouseEnter={() => !renderTooltip && setRenderTooltip(true)}
            className='display-contents'
            style={tooltipContainerStyles}>
            {!renderTooltip && children}
            {renderTooltip && (
                <MUITooltip {...rest} arrow>
                    {children}
                </MUITooltip>
            )}
        </div>
    );
};

export default Tooltip;

export const tooltipComponentPropsV1 = {
    popper: { sx: { maxWidth: 'none', zIndex: 3000 } },
    tooltip: {
        sx: {
            maxWidth: '500px',
            padding: '12px 24px 12px 24px',
            fontFamily: 'GraphikRegular',
            color: '#57626a',
            fontSize: '14px',
            backgroundColor: '#FFF',
            filter: 'drop-shadow(0px 0px 7.68px rgba(0, 0, 0, 0.3))',
        },
    },
};

export const tooltipSlotPropsV1 = {
    arrow: {
        sx: {
            '&::before': {
                color: '#FFF',
            },
        },
    },
};

type TooltipV1Props = {
    title: React.ReactNode;
} & CFRATooltipProps;

export const TooltipV1 = ({ children, title, ...rest }: TooltipV1Props) => {
    return (
        <Tooltip
            title={title}
            componentsProps={tooltipComponentPropsV1}
            slotProps={tooltipSlotPropsV1}
            arrow
            {...rest}>
            <Box sx={{ display: 'inline-flex' }}>{children}</Box>
        </Tooltip>
    );
};
